import {
    rqget,
    rqpost,
    upfiles
} from '../utils/request';
export function login(logininfo) {
    return rqpost("/login", logininfo);
}
export function getSpace(logininfo) {
    return rqget("/api/getSpace", logininfo);
}
export function getallzuzhaos(param) {
    return rqpost("/getallzuzhaos", param);
}
export function tianjiazuzhao(param) {
    return rqpost("/tianjiazuzhao", param);
}
export function huodezuzhaoxinxi(param) {
    return rqpost("/huodezuzhaoxinxi", param);
}
export function gengxinzuzhaoxinxi(param) {
    return rqpost("/gengxinzuzhaoxinxi", param);
}
export function tianjiabiaoqian(param) {
    return rqpost("/tianjiabiaoqian", param);
}
export function huodebiaoqian(param) {
    return rqpost("/huodebiaoqian", param);
}
export function gengxinbiaoqian(param) {
    return rqpost("/gengxinbiaoqian", param);
}
export function tianjiashuiyin(param) {
    return rqpost("/tianjiashuiyin", param);
}
export function getshuiyin(param) {
    return rqpost("/getshuiyin", param);
}
export function gengxinshuiyin(param) {
    return rqpost("/gengxinshuiyin", param);
}
export function shangchuangshipin(param) {
    return rqpost("/shangchuangshipin", param);
}
export function shuaxinshangchuanshipin(param) {
    return rqpost("/shuaxinshangchuanshipin", param);
}
export function xierushipinxinxi(param) {
    return rqpost("/xierushipinxinxi", param);
}
export function huodezuzhaotupian(param) {
    return rqpost("/huodezuzhaotupian", param);
}
export function huodezuzhaoshipin(param) {
    return rqpost("/huodezuzhaoshipin", param);
}
export function gengxintupianxinxi(param) {
    return rqpost("/gengxintupianxinxi", param);
}
export function gengxinshipinxinxi(param) {
    return rqpost("/gengxinshipinxinxi", param);
}
export function tianjiazhuanti(param) {
    return rqpost("/tianjiazhuanti", param);
}
export function huodezhuantiliebiao(param) {
    return rqpost("/huodezhuantiliebiao", param);
}
export function huodebaiduauth(param) {
    return rqpost("/huodebaiduauth", param);
}
export function huodebaiduuser(param) {
    return rqpost("/huodebaiduuser", param);
}
export function huodebaidurongliang(param) {
    return rqpost("/huodebaidurongliang", param);
}
export function getzuzhaofromid(param) {
    return rqpost("/getzuzhaofromid", param);
}
export function kaishiqianyi(param) {
    return rqpost("/kaishiqianyi", param);
}
export function huodezhuantiinfo(param) {
    return rqpost("/huodezhuantiinfo", param);
}
export function gengxinzhuanti(param) {
    return rqpost("/gengxinzhuanti", param);
}
export function huodezhuantizuzhao(param) {
    return rqpost("/huodezhuantizuzhao", param);
}
export function tianjiazuzhaodaozhuanti(param) {
    return rqpost("/tianjiazuzhaodaozhuanti", param);
}
export function yichuzhuantizuzhao(param) {
    return rqpost("/yichuzhuantizuzhao", param);
}
export function huodegerenxinxi(param) {
    return rqpost("/huodegerenxinxi", param);
}
export function weixinzhifu(param) {
    return rqpost("/weixinzhifu",param);
}
export function addloginlog(param) {
    return rqpost("/addloginlog", param);
}
export function tianjiatongzhi(param) {
    return rqpost("/tianjiatongzhi", param);
}
export function chaxunzuzhao(param) {
    return rqpost("/chaxunzuzhao", param);
}
export function toguidang(param) {
    return rqpost("/toguidang", param);
}
export function huodeguidangzuzhao(param) {
    return rqpost("/huodeguidangzuzhao", param);
}
export function chaxunguidangzuzhao(param) {
    return rqpost("/chaxunguidangzuzhao", param);
}
export function hufuzuzhao(param) {
    return rqpost("/hufuzuzhao", param);
}
export function chaxunzhuanti(param) {
    return rqpost("/chaxunzhuanti", param);
}
export function xiugaimima(param) {
    return rqpost("/xiugaimima", param);
}
export function lunxunzhifuzhuangtai(param) {
    return rqpost("/lunxunzhifuzhuangtai", param);
}
export function sendcode(param) {
    return rqpost("/sendcode", param);
}
export function register(param) {
    return rqpost("/register", param);
}
export function huodequanxian(param) {
    return rqpost("/huodequanxian", param);
}
export function shengchenglianjie(param) {
    return rqpost("/shengchenglianjie", param);
}
export function checkyaoqingma(param) {
    return rqpost("/checkyaoqingma", param);
}
export function sendcode2(param) {
    return rqpost("/sendcode2", param);
}
export function chongzhimima(param) {
    return rqpost("/chongzhimima", param);
}
export function huodetongzhi(param) {
    return rqpost("/huodetongzhi", param);
}
export function gengxintishi(param) {
    return rqpost("/gengxintishi", param);
}
export function gengxinneirong(param) {
    return rqpost("/gengxinneirong", param);
}
export function shanchutishi(param) {
    return rqpost("/shanchutishi", param);
}
export function huodechongzhijilu(param) {
    return rqpost("/huodechongzhijilu", param);
}
export function gengxinweight(param) {
    return rqpost("/gengxinweight", param);
}
export function huodeyonghuliebiao(param) {
    return rqpost("/huodeyonghuliebiao", param);
}
export function zhucerenlian(param) {
    return rqpost("/zhucerenlian", param);
}
export function updateacctokreshtok(param) {
    return rqpost("/updateacctokreshtok", param);
}
